import * as React from 'react'
import _ from 'lodash'
import { Cursor } from 'src/lib/Cursor';
import * as Model from 'src/types/document'
import { referredOrOwnNodeId } from 'src/model/nodeInfo';
import { Stack, stacksAreEqual, canDragFromStackIntoStack } from 'src/types/stack';
import { stackToBlockPath, stackToBlockC } from 'src/model/evaluate';

export interface HoveredNodeContext {
  nodeId?: Model.NodeId,
  stack?: Stack,
  set?: (nodeId: Model.NodeId, stack: Stack) => void,
  clear?: () => void,
  is?: (nodeId: Model.NodeId, stack: Stack) => boolean,
}

const {Provider, Consumer} = React.createContext({} as HoveredNodeContext)

export class HoveredNodeState extends React.Component {

  state = {
    nodeId: undefined as Model.NodeId | undefined,
    stack: undefined as Stack | undefined,
  }

  render() {
    const { nodeId, stack } = this.state

    return <Provider value={{
      nodeId, stack,
      set: this.setHoveredNode,
      clear: this.clearHoveredNode,
      is: this.isHoveredNode,
    }}>
      {this.props.children}
    </Provider>
  }

  setHoveredNode = (nodeId: Model.NodeId, stack: Stack) => {
    const blockC = stackToBlockC(stack)
    const effectiveNodeId = referredOrOwnNodeId(blockC, nodeId)
    if (effectiveNodeId !== this.state.nodeId || !_.isEqual(stack, this.state.stack)) {
      this.setState({ nodeId: effectiveNodeId, stack })
    }
  }

  clearHoveredNode = () => {
    if (this.state.nodeId || this.state.stack) {
      this.setState({ nodeId: undefined, stack: undefined })
    }
  }

  isHoveredNode = (nodeId: Model.NodeId, stack: Stack): boolean => {
    const blockC = stackToBlockC(stack)
    return referredOrOwnNodeId(blockC, nodeId) === this.state.nodeId
            && !!this.state.stack
            && (canDragFromStackIntoStack(stack, this.state.stack)
                || canDragFromStackIntoStack(this.state.stack, stack))
  }
}

export const HoveredNodeConsumer = Consumer


// WEBPACK FOOTER //
// ./src/view/HoveredNodeContext.tsx